// extracted by mini-css-extract-plugin
export var lg = "_gz-7";
export var md = "_gz-6";
export var placeholderContainer = "_gz-1";
export var placeholderIcon = "_gz-2";
export var productImage = "_gz-0";
export var sm = "_gz-5";
export var xl = "_gz-8";
export var xs = "_gz-4";
export var xxs = "_gz-3";